import React, { useState, useRef } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import PanZoom from 'react-easy-panzoom';

const ImageUploader = () => {
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ aspect: 1 });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [rotation, setRotation] = useState(0);
  const imageRef = useRef(null);

  const onImageChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const rotateImage = (angle) => {
    setRotation((prevRotation) => prevRotation + angle);
  };

  const getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error('Canvas is empty');
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(blob);
        let fileUrl = window.URL.createObjectURL(blob);
        resolve(fileUrl);
      }, 'image/jpeg');
    });
  };

  const onSaveCrop = async () => {
    const croppedImageUrl = await getCroppedImg(imageRef.current, completedCrop, 'cropped.jpeg');
    console.log('Cropped Image URL:', croppedImageUrl);
  };

  return (
    <div>
      <input type="file" onChange={onImageChange} />
      {image && (
        <div>
          <PanZoom>
            <ReactCrop
              src={image}
              crop={crop}
              onChange={(newCrop) => setCrop(newCrop)}
              onComplete={(c) => setCompletedCrop(c)}
              style={{ transform: `rotate(${rotation}deg)` }}
              imageStyle={{ maxWidth: '100%' }}
              ref={imageRef}
            />
          </PanZoom>
          <div>
            <button onClick={() => rotateImage(90)}>Rotate 90°</button>
            <button onClick={() => rotateImage(-90)}>Rotate -90°</button>
            <button
              onClick={onSaveCrop}
              style={{ background: "#ef4d39", color: "white" }}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
